import React from 'react';
import Navigation from './Navigation';
import { Program, programs } from './data';

interface WhatProps {
  onChange: (program: Program) => void;
  onBack: () => void;
}

export default function What({
  onChange, onBack,
}: WhatProps) {
  const handleClick = (program: Program) => () => {
    onChange(program);
  };

  return (
    <div>
      <h2>For which program?</h2>
      <p>
        You can recognise the person selected for the following
        programs:
      </p>

      <div className="recognition-what">
        {
          programs.map((program) => (
            <div key={program.id} className="recognition-what-item" onClick={handleClick(program)} role="button" tabIndex={0} onKeyUp={handleClick(program)}>
              <div className="recognition-what-item-image" style={{ backgroundImage: `url(${program.image})` }} />
              <div className="recognition-what-item-details">
                <h3>{program.title}</h3>
                <p>{program.description}</p>
              </div>
            </div>
          ))
        }
      </div>

      <Navigation
        back="Back"
        onBack={onBack}
      />
    </div>
  );
}
